<template>
  <CardTable
    :title="title"
    :columns="columns"
    :rows="rows"
    :isLoading="isLoading"
    :pagination="false"
  >
    <template slot="action">
      <b-button :to="{ name: 'InvoicesGenerate' }" variant="primary" size="sm">New Invoice</b-button>
    </template>
    <template #cell(totalAmount)="data">
      {{ numberFormat(data.item.totalAmount) }}
    </template>
    <template #cell(createdAt)="data">
      {{ dateTimeFormat(data.item.createdAt, "") }}
    </template>
  </CardTable>
</template>

<script>
import { dateTimeFormat, numberFormat } from "@/shared/utils";
import { recentUpdatedInvoices as columns } from "@/shared/columns";

export default {
  data: () => ({
    title: "Recent Invoices",
    columns,
    rows: [],
    isLoading: true,
    serverParams: {
      pageNumber: 1,
      pageSize: 10,
      orderBy: "createdAt desc",
    },
  }),
  created() {
    const self = this;
    self.getAll();
  },
  methods: {
    dateTimeFormat,
    numberFormat,
    getAll() {
      const self = this;

      self.isLoading = true;
      self.$store
        .dispatch("apis/get", {
          url: "/transaction/invoice",
          params: self.serverParams,
        })
        .then((response) => {
          if (response.error) {
            self.$message.error({
              zIndex: 10000,
              message: response.message,
            });
          } else {
            self.rows = response.data.data;
          }
          self.isLoading = false;
        });
    },
  },
};
</script>